
const Footer = () => {
    return (
        <footer className="py-[8px]">
            <p className="block md:text-sm font-normal text-[#616161] text-center">
            Copyright 2024 OGACHI CERAMICS Co.,Ltd.
            </p>
        </footer>
    );
};

export default Footer;